import $ from 'jquery'
import {
  prepareChessboard,
  validateDrag,
  validateDrop,
  validatePosition,
  validateCoordinates,
  showReminder
} from '../../utils'
import { WRONG_ANSWER_AUDIO, CORRECT_ANSWER_AUDIO } from '../../utils/constants';

/**
* @name selectCoordinates
* @function
* @param {config}
* @description: Select the coordinates from the chess board
*/
export function selectCoordinates(config) {
  let afterLoad = function () {
    let squares = config.squares,
      coordinateClass = 'white-coordinate',
      next = config.next;

    prepareChessboard(config);

    var correctClick = false;

    var board = document.getElementsByClassName("chessboard-63f37");
    $(board[0]).click(function (e) {
      e.preventDefault();
      if (!correctClick) {
        $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
      }
      correctClick = false;
    })

    squares.map((k) => {
      $(k).addClass(coordinateClass);

      return $(k).click(function (e) {
        e.preventDefault();
        correctClick = true;
        $(this).removeClass(coordinateClass);
        $(document).trigger('bubble-hide');
        showReminder($('.' + coordinateClass).length);
        $(document).trigger("audio-play", CORRECT_ANSWER_AUDIO);
        validateCoordinates(coordinateClass, next, 0);
      });
    })
  }
  const chessConfig = {
    config: {},
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name highlightCoordinates
* @function
* @param {lessonConfig}
* @description: Highlight the coordinates
*/
export function highlightCoordinates(config) {
  let afterLoad = function () {
    let next = config.next,
      coordinates = config.coordinates ? config.coordinates : [],
      prefilledCoordinates = config.prefilledCoordinates ? config.prefilledCoordinates : [],
      coordinateCount = coordinates.length + prefilledCoordinates.length,
      coordinateClass = config.coordinateClass,
      count = 0;
    var correctClick = false;

    prepareChessboard(config);

    let taskInterval = setInterval(function () {
      $(prefilledCoordinates[count]).addClass(coordinateClass);

      if (count === 7) {
        clearInterval(taskInterval);
      } else {
        count++;
      }
    }, 100);

    var board = document.getElementsByClassName("chessboard-63f37");
    $(board[0]).click(function (e) {
      e.preventDefault();
      if (!correctClick) {
        $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
      }
      correctClick = false;
    })

    coordinates.map((k) => {
      return $(k).click(function (e) {
        e.preventDefault();
        correctClick = true;
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
        $(this).addClass(coordinateClass);
        $(document).trigger('bubble-hide');        
        showReminder(16 - ($('.' + coordinateClass).length));
        validateCoordinates(coordinateClass, next, coordinateCount)
      });
    })
  }
  const chessConfig = {
    config: {},
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name dragDropPieces
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/
export function dragDropPieces(config) {
  let next = config.next,
    fen = config.fen,
    piecesArray = config.piecesArray ? config.piecesArray : [],
    validatePieces = config.validatePieces ? config.validatePieces : [],
    pieceLimit = config.pieceLimit,
    celebrationSound = config.celebrationSound ? config.celebrationSound : false;
    

  let afterLoad = function () {
    let coordinates = config.coordinates;

    prepareChessboard(config);
    coordinates && coordinates.map((k) => {
      return $(k).addClass("white-coordinate");
    })
  }

  let onDragStart = function (source, piece, position, orientation) {
    validateDrag(piece, pieceLimit[piece])
  };

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    validatePosition(piecesArray.length, fen, next, null,  config.isQA, celebrationSound)
    return validateDrop(piece, pieceLimit[piece], target, validatePieces, celebrationSound)
  }

  const chessConfig = {
    config: {
      draggable: true,
      dropOffBoard: 'trash',
      sparePieces: true,
      onDrop: onDrop,
      onDragStart: onDragStart,
      pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_1/assignments.js